/**
 * Reset all background attributes
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

import { resetResponsiveAttributes } from '../../../common';
import { BackgroundAttributes, BackgroundValues } from '../../types';

/**
 * Reset all background attributes
 */
export const resetBackgroundAttributes =
	(): Partial< BackgroundAttributes > => {
		return resetResponsiveAttributes< BackgroundValues >();
	};
